/**
 * Converts a read-through number to its ordinal label.
 * e.g. 1 → "First", 2 → "Second", 3 → "Third", 4 → "4th"
 */
export const readThroughLabel = (n: number): string => {
  if (n === 1) return 'First';
  if (n === 2) return 'Second';
  if (n === 3) return 'Third';
  return `${n}th`;
};

/**
 * Formats a total number of minutes into a human-readable string.
 * e.g. 90 → "1h 30m", 60 → "1h", 45 → "45m", 0 → "0m"
 */
export const formatMinutesToHuman = (totalMinutes: number): string => {
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (hours > 0 && mins > 0) return `${hours}h ${mins}m`;
  if (hours > 0) return `${hours}h`;
  return `${mins}m`;
};
